import { RouteObject } from 'react-router-dom'

// lazy => lightweight-charts и код графика уезжают в отдельный чанк
// и не тянутся в основной бандл на логине/дашборде.
const route: RouteObject = {
  path: '/market/:slug',
  lazy: async () => ({ Component: (await import('./scene')).default })
}

export default route
